import { LocaleEnum } from '../enums/locale.enum';

export namespace LocaleStateActions {
  export class SetLocale {
    static readonly type = '[Locale] SetLocale';

    constructor(public readonly locale: LocaleEnum) {}
  }
}
